import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24de1433"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containerTop" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消预约")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消预约")

import { Dialog, Toast } from 'vant';
import { Ref, ref, onMounted, onBeforeUnmount } from "vue";
import Api from "@/http/api/index";
import { getCurrentInstance } from 'vue'
import BarCode from "../../../components/barCode.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { proxy } = getCurrentInstance()
const active = ref(0);
// const total = ref(0);
// const page = ref(1);
const show = ref(false);
const SNCode = ref("");
const SnIdx = ref("");
const list = ref([
]);
const isListEmpty: Ref<boolean> = ref(false);

const timer = ref();
const titles = ref([
    { title: '我的预约', name: '0' },
    { title: '历史预约', name: '1' },
])
// const finished = ref(false);
const refreshing = ref(false);

// const loading = ref(false);
const onClickTab = ({ title, name }) => {
    // console.log(title,"title");
    // console.log(name,"name");

    // console.log(active.value);
    list.value = [];
    // page.value=1;
    // loading.value =true;
    // finished.value =false;
    getAppointRecordListApi(name)

};


//出示兑换码
function showDhCode(val: string, inx) {

    show.value = true;
    SNCode.value = val;
    SnIdx.value = inx;


}
// 关闭遮罩事件
function closeDialog() {
    // console.log("关闭遮罩");
    // clearInterval(this.timer);
}
// 取消预约事件
function cancleRecover(item) {
    Dialog({
        showCancelButton: true,
        message:
            `确认取消  ` + item.appointDatetime + ` 点的预约记录吗？`,

    }).then(() => {
        getTaxRecoverKillApi(item.appointGovRecordId)
    }).catch(() => {
        // on cancel
    });

}

// 取消预约方法api
function getTaxRecoverKillApi(val) {

    Api.getTaxRecoverKill({
        params: {
            memberId: proxy.$route.query.memberId + '',
            appointGovRecordId: val,
        },
        success: (value) => {
            // console.log("success", value);
            // 空数据 停止加载
            if (value.code == 0) {
                Toast('取消成功');
                location.reload();
            } else {
                Toast(value.msg);
            }
        },
        fail: (value) => {
            console.log("fail", value);
        },
    });
}
// 分页功能：滚动加载很多
const onLoad = () => {

    // let timer = setTimeout(() => {	// 定时器仅针对本地数据渲染动画效果,项目中axios请求不需要定时器
    //     getAppointRecordListApi(active.value);					// 调用上面方法,请求数据
    //     page.value++;					// 分页数加一
    //     finished.value && clearTimeout(timer);//清除计时器
    // }, 100);

};

const onRefresh = () => {
    // refreshing.value = true;
    // loading.value = true; 			// 将 loading 设置为 true，表示处于加载状态
    // page.value = 1;				// 分页数赋值为1
    list.value = [];				// 清空数组
    getAppointRecordListApi(active.value, () => {
        setTimeout(() => {
            refreshing.value = false;
        }, 600)
    });
    // onLoad(); 				// 重新加载数据
}
// 获取预约记录列表api
function getAppointRecordListApi(status, success?: () => void, fail?: () => void) {
    // console.log(status,'status');

    // loading.value =true;
    Api.getAppointRecordList({
        params: {
            memberId: proxy.$route.query.memberId + '',
            type: status,//0：当前预约记录 1：历史预约记录
            page: '1',
            size: '9999',
        },

        success: (value) => {
            success && success()
            console.log("success", value);
            if (value.code == 0) {
                if (value.data.length == 0) {
                    isListEmpty.value = true
                } else {
                    isListEmpty.value = false
                }
                list.value.splice(0, list.value.length, ...value.data.list as []);
                // list.value.push(...listData);
            } else {
                // loading.value =false;
                Toast(value.msg)
            }

            // 分页逻辑
            // if(value.code ==0){
            //     loading.value =false;
            // // 空数据 停止加载
            // if (value.data.list.length == 0) {
            //     list.value = [];
            //     finished.value = true;
            // }
            // // 有数据 赋值列表 加载状态结束
            // value.data.list.forEach(item => {
            //     list.value.push(item);
            // })

            // loading.value = false;
            // refreshing.value = false;

            // // 如果list长度大于等于总数据条数，数据全部加载完成
            // if (list.value.length >= value.data.count) {
            //     finished.value = true;//结束加载
            // }
            // console.log(list.value,'7777')
            // }else{
            //     loading.value =false;
            //     Toast(value.msg)
            // }

        },
        fail: (value) => {
            console.log("fail", value);
            fail && fail();
        },
    });
}

onMounted(() => {
    // console.log(proxy.$route.query.memberId, "proxy.$route.query.memberId");
    getAppointRecordListApi(active.value);
    // 20s 刷新一次
    timer.value = setInterval(() => {	// 定时器仅针对本地数据渲染动画效果,项目中axios请求不需要定时器
        getAppointRecordListApi(active.value);

    }, 20000);
});
onBeforeUnmount(() => {
    clearInterval(timer.value);
})

return (_ctx: any,_cache: any) => {
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_dialog, {
      class: "van-dialog",
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      title: "核销码",
      "show-cancel-button": false,
      "show-confirm-button": false,
      "close-on-click-overlay": true,
      onClose: closeDialog,
      "message-align": "center"
    }, {
      default: _withCtx(() => [
        _createVNode(BarCode, {
          SNCode: SNCode.value,
          SnIdx: SnIdx.value
        }, null, 8, ["SNCode", "SnIdx"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_tabs, {
      active: active.value,
      "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((active).value = $event)),
      class: "van-tabs",
      onClickTab: onClickTab
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titles.value, (a, b) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            key: b,
            title: a.title,
            name: a.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_pull_refresh, {
                modelValue: refreshing.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
                "success-text": "刷新成功",
                onRefresh: onRefresh
              }, {
                default: _withCtx(() => [
                  (isListEmpty.value)
                    ? (_openBlock(), _createBlock(_component_van_empty, {
                        key: 0,
                        description: "暂无记录"
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(list.value, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "list",
                          key: idx
                        }, [
                          _createElementVNode("div", _hoisted_2, "预约时段:" + _toDisplayString(item.appointDatetime), 1),
                          (active.value == 0 && item.appointGovRecordId != '0')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "status status_red",
                                onClick: ($event: any) => (showDhCode(item.appointCode, idx))
                              }, " 出示核销码 ", 8, _hoisted_3))
                            : _createCommentVNode("", true),
                          _createVNode(_component_van_cell, {
                            class: "van-cell",
                            title: "预约人",
                            value: item.realName + '(' + item.phone + ')'
                          }, null, 8, ["value"]),
                          _createVNode(_component_van_cell, {
                            title: "身份证",
                            value: item.idNumber
                          }, null, 8, ["value"]),
                          _createVNode(_component_van_cell, {
                            title: "预约部门",
                            value: item.appointGovDepartName
                          }, null, 8, ["value"]),
                          _createVNode(_component_van_cell, {
                            title: "预约事项名称",
                            value: item.appointGovItemName
                          }, null, 8, ["value"]),
                          (a.title == '我的预约')
                            ? (_openBlock(), _createBlock(_component_van_cell, {
                                key: 1,
                                title: "预约状态"
                              }, {
                                "right-icon": _withCtx(() => [
                                  (item.appointGovRecordId == '0')
                                    ? (_openBlock(), _createBlock(_component_van_button, {
                                        key: 0,
                                        plain: "",
                                        type: "default",
                                        size: "mini",
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_4
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_van_button, {
                                        key: 1,
                                        plain: "",
                                        type: "danger",
                                        size: "mini",
                                        onClick: ($event: any) => (cancleRecover(item))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_5
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (a.title == '历史预约')
                            ? (_openBlock(), _createBlock(_component_van_cell, {
                                key: 2,
                                title: "预约状态",
                                value: item.appointDhStatusName
                            
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}
}

})